import React from 'react';

const PageLoader = () => (
  <div
    className="h-screen w-screen absolute top-0 left-0 z-9999 flex items-center justify-center"
    data-testid="page-loader"
  >
    <div className="relative w-page-loader-width h-page-loader-height">
      <svg
        className="absolute top-0 w-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 111.77 111.77"
      >
        <circle
          cx="55.89"
          cy="55.89"
          r="55.64"
          fill="none"
          stroke="#BABABA"
          strokeMiterlimit="10"
          strokeWidth=".5"
          strokeDasharray="4"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="111.77"
          height="111.77"
          viewBox="0 0 220 220"
        >
          <path
            fill="none"
            d="M9 10h200v200H9V10zm132.88 191.092c23.568-5.808 60.698-34.833 64.722-83.592 3.55-43.02-21.35-84.452-64.166-100.202-42.876-15.772-91 .37-115.9 38.57C1.616 94.098 6.324 144.39 37.914 177.51c30.073 31.53 74.547 35.552 100.542 24.82L109.3 174.812v11.847c-31.622 2.67-68.982-23.935-76.804-60.883C24.334 87.22 46.803 47.665 84.724 35.34c38.205-12.42 79.846 6.712 95.75 43.53 14.645 33.9.89 71.473-17.622 85.435v-5.635c0-29.165.015-58.33-.035-87.495-.003-1.772.107-4.096-.894-5.22-4.025-4.515-8.47-8.658-13.326-13.508l-38.98 61.725-38.85-60.795c-4.445 4.173-8.522 7.79-12.306 11.692-1 1.033-1.527 2.937-1.55 4.45-.422 26.98-.74 53.964-1.043 80.946-.015 1.305-.2 3.1.532 3.842 5.904 5.985 12.22 11.474 20.787 15.33v-65.456c.284-.076.57-.152.853-.23l31.568 49.58 31.267-49.035 1.007.355v96.24z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FF5500"
            d="M141.88 201.092v-96.238l-1.006-.355-31.267 49.035c-10.75-16.883-21.16-33.23-31.568-49.58-.285.076-.57.152-.854.23v65.456c-8.566-3.856-14.883-9.345-20.788-15.33-.73-.742-.547-2.537-.532-3.842.304-26.982.62-53.965 1.042-80.945.024-1.515.55-3.418 1.552-4.452 3.784-3.9 7.86-7.52 12.307-11.69l38.848 60.794c12.923-20.464 25.597-40.53 38.98-61.725 4.856 4.85 9.3 8.992 13.325 13.508 1 1.123.89 3.446.894 5.22.05 29.164.035 58.33.035 87.494v5.635c18.51-13.962 32.266-51.534 17.62-85.436-15.903-36.816-57.544-55.948-95.75-43.53-37.92 12.327-60.39 51.884-52.227 90.44 7.822 36.947 45.182 63.55 76.804 60.88v-11.846c10.417 9.83 19.716 18.607 29.156 27.518-25.994 10.73-70.47 6.71-100.542-24.82C6.325 144.393 1.616 94.098 26.536 55.87c24.9-38.2 73.024-54.343 115.9-38.57C185.25 33.048 210.152 74.48 206.6 117.5c-4.022 48.76-41.152 77.784-64.72 83.592z"
          />
        </svg>
      </svg>

      <svg
        className="animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 111.8 111.8"
      >
        <circle fill="#44DAF9" cx="28.3" cy="7.6" r="3" />
      </svg>
    </div>
  </div>
);

export default PageLoader;
